import React from 'react'
import Checkmark from '../../assets/icons/checkmark.svg'
import DetailsCard from '../DetailsCard'
import verification1 from '../../assets/images/processes/verification1.png'
import verification2 from '../../assets/images/processes/verification2.png'


const VerificationProcess = ({setData, setModal}) => {
    const syllabus = [
        {
          id: 1,
          name: 'Verification process',
          icon: Checkmark,
          alt: 'Checkmark_icon',
          title: 'Verification process',
          title_icon: Checkmark,
          images : [
            {
              id: 1,
              img: verification1,
            },
            {
              id: 2,
              img: verification2,
            },
          ],
          img_alt : 'entry_image'
        },
      ]

      const handleModal = (item) => {
        setModal(item)
        setData(item)
      }

      
  return (
    <div className='flex items-center justify-between w-full flex-wrap mt-11 md:justify-start'>
            {syllabus.map((item) => {
              return(
                <DetailsCard onClick={()=>handleModal(item)} key={item.id} data={item} index={item.id} />
              )
            })}
    </div>
  )
}

export default VerificationProcess
